'use strict';
export default ['translator', (translator) => {
    $.datepicker.regional['et'] = {
        firstDay: 1,
        dateFormat: "dd.mm.yy",
        prevText: "Eelmine kuu",
        nextText: "Järgmine kuu",
        dayNames: ["Pühapäev", "Esmaspäev", "Teisipäev", "Kolmapäev", "Neljapäev", "Reede", "Laupäev"],
        dayNamesMin: ["P", "E", "T", "K", "N", "R", "L"],
        dayNamesShort: ["P", "E", "T", "K", "N", "R", "L"],
        monthNames: ["Jaanuar", "Veebruar", "Märts", "Aprill", "Mai", "Juuni", "Juuli", "August", "September", "Oktoober", "November", "Detsember"],
        monthNamesShort: ["Jaan", "Veebr", "Märts", "Apr", "Mai", "Juuni", "Juuli", "Aug", "Sept", "Okt", "Nov", "Dets"]
    };
    $.datepicker.regional["en"] = {
        firstDay: 1,
        dateFormat: "dd.mm.yy",
        prevText: "Previous month",
        nextText: "Next month",
        monthNames: ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ],
        monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    };

    $.datepicker.setDefaults($.datepicker.regional['et']);

    translator.bind(translator.Event.LANGUAGE_CHANGED, function () {
        if (typeof $ != 'undefined' && typeof $.datepicker != 'undefined') {
            $.datepicker.setDefaults($.datepicker.regional[translator.getLanguage()]);
        }
    });

    class Datepicker {
        restrict = 'A';
        require = 'ngModel';
        link = function (scope, element, attrs, ngModelCtrl) {
            $(function () {
                var field = $(element);

                field.parent().find('.button').click(function () {
                    field.datepicker('show');
                    field.focus().click();
                });
                if (field.parents('.fancybox-wrap').length) {
                    //ideally i would make it to reposition by itself, but refresh is not doing it.
                    $('.fancybox-wrap, .fancybox-skin').on('scroll touchmove', function () {
                        if (!field.is(':focus')) {
                            return;
                        }
                        var dialog = field.datepicker('widget');
                        if (dialog.is(':visible')) {
                            var offset = field.offset().top - $(window).scrollTop();
                            dialog.css('top', offset + field.outerHeight());
                        }
                    });
                }

                field.datepicker({
                    onSelect: function (date) {
                        ngModelCtrl.$setViewValue(date);
                        scope.$apply();
                    }
                });
            });
        };
    }

    return new Datepicker();
}];


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/decorator/datepicker.directive.js